import React from 'react';

import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import { useHistory, useLocation } from 'react-router-dom';
import useProjectsFilters from '../../hooks/useProjectsFilters';

function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export default function ProjectsFilterTags() {
  const projectFilters = useProjectsFilters();
  const history = useHistory();
  const { search } = useLocation();

  if (projectFilters == null) {
    return <></>;
  }

  const { filters } = projectFilters;

  return (
    <Row spacing="300" wrap="down">
      {Array.from(filters, ([key, value]) => {
        return (
          <Tag
            key={`${key}-${value}`}
            onClose={() => {
              const searchParams = new URLSearchParams(search);
              searchParams.delete(key);
              history.push({
                pathname: '/projects',
                search: searchParams.toString() ? `?${searchParams}` : '',
              });

              // Then remove the filter from the context and also ProjectListPage useEffect will handle syncing the filters with the URL
            }}
            closeLabel="Remove filter"
          >
            {`${toTitleCase(key)}: ${value}`}
          </Tag>
        );
      })}
    </Row>
  );
}
